import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => style(theme));

const propTypes = {
    mapId: PropTypes.string.isRequired
};

function Attribution({ mapId }) {
    const classes = useStyles();

    const layers = useSelector(state => state.layers.layers);
    const baseLayer = useSelector(state => state.layers.baseLayer);
    const activeLayers = useSelector(state => state.activeLayers);
    const zoom = useSelector(
        state => state[mapId].cameraOptions && state[mapId].cameraOptions.zoom
    );
    // Also should get bbox

    const [isOpen, setIsOpen] = useState(false);

    function formatAttribution() {
        const baseLayerAttributions =
            baseLayer.attribution && zoom
                ? baseLayer.attribution
                      .filter(a => a.coverageAreas.some(withinCoverageArea))
                      .map(a => a.attribution)
                : [baseLayer.license];

        let attribution = [
            // '© Crown copyright and database rights 2021 Ordnance Survey 100024198',
            ...baseLayerAttributions,
            ...activeLayers
                .filter(al => al.visible || al.pinned)
                .filter(al => !al.ignoreAttribution)
                .map(al => layers.find(l => l.system_name === al.systemName).license)
        ];

        return [...new Set(attribution.filter(v => v))];
    }

    function withinCoverageArea(coverageArea) {
        return (
            (!coverageArea.maxzoom || zoom < coverageArea.maxzoom) &&
            (!coverageArea.minzoom || zoom >= coverageArea.minzoom)
        );
        // TODO - Also check against bbox
    }

    const attribution = formatAttribution();
    return (
        attribution && (
            <div className={classes.root}>
                {isOpen ? (
                    <Typography classes={{ root: classes.attributionText }}>
                        <span>{attribution.join(' | ')}</span>
                    </Typography>
                ) : (
                    <Typography
                        classes={{ root: classes.attributionText }}
                        component="div">
                        <div className={classes.ellipsis}>
                            {attribution.join(' | ')}
                        </div>
                    </Typography>
                )}
                {attribution.length > 1 && (
                    <Typography classes={{ root: classes.seeMoreButton }}>
                        <strong
                            className={classes.seeMoreText}
                            onClick={e => setIsOpen(!isOpen)}>
                            {isOpen
                                ? 'Hide attribution information'
                                : 'See all attribution information'}
                        </strong>
                    </Typography>
                )}
            </div>
        )
    );
}

const style = theme => ({
    root: {
        display: 'flex',
        zIndex: 3,
        width: 'fit-content',
        backgroundColor: theme.palette.grey.variant5,
        opacity: '0.75',
        padding: '13px 20px',
        boxSizing: 'border-box',
        position: 'absolute',
        bottom: 0,
        right: 0,
        maxWidth: '540px',
        padding: '2px 5px',
        color: theme.palette.primary.main,
        '&:hover': {
            opacity: '1'
        }
    },
    attributionText: {
        fontSize: '10px',
        display: 'inline',
        columnGap: '5px'
    },
    seeMoreButton: {
        marginLeft: '5px',
        fontSize: '10px'
    },
    seeMoreText: {
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    ellipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '380px'
    }
});

Attribution.propTypes = propTypes;

export default Attribution;
